var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllAssetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3383_14228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.75 16.25H6.25C4.875 16.25 3.75 17.375 3.75 18.75V23.75C3.75 25.125 4.875 26.25 6.25 26.25H23.75C25.125 26.25 26.25 25.125 26.25 23.75V18.75C26.25 17.375 25.125 16.25 23.75 16.25ZM8.75 23.75C7.375 23.75 6.25 22.625 6.25 21.25C6.25 19.875 7.375 18.75 8.75 18.75C10.125 18.75 11.25 19.875 11.25 21.25C11.25 22.625 10.125 23.75 8.75 23.75ZM23.75 3.75H6.25C4.875 3.75 3.75 4.875 3.75 6.25V11.25C3.75 12.625 4.875 13.75 6.25 13.75H23.75C25.125 13.75 26.25 12.625 26.25 11.25V6.25C26.25 4.875 25.125 3.75 23.75 3.75ZM8.75 11.25C7.375 11.25 6.25 10.125 6.25 8.75C6.25 7.375 7.375 6.25 8.75 6.25C10.125 6.25 11.25 7.375 11.25 8.75C11.25 10.125 10.125 11.25 8.75 11.25Z",
    fill: "#5177FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3383_14228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllAssetIcon);
export default __webpack_public_path__ + "static/media/all_asset_icon.f4d514588ef4a3435fb7ea8d55ab8bef.svg";
export { ForwardRef as ReactComponent };